export default __webpack_public_path__ + "static/media/UsersInactiveLight.29bafce8.svg";